<template>
  <div class="fee-list-page">
    <div class="statistics-container">
      <div class="statistic-card card-primary">
        <div class="statistic-value statistic-value--amount">
          <span>{{ displayCardValue(cardData.receivableAmount) }}</span>
          <span v-if="cardData.standardCurrency" class="statistic-currency">{{ cardData.standardCurrency }}</span>
        </div>
        <div class="statistic-label">{{ $t('feeTab.receivableTotal') }}</div>
      </div>
      <div class="statistic-card card-warning">
        <div class="statistic-value">{{ displayCardValue(cardData.pendingReceivableAmount) }}</div>
        <div class="statistic-label">{{ $t('feeTab.receivablePending') }}</div>
      </div>
      <div class="statistic-card card-success">
        <div class="statistic-value">{{ displayCardValue(cardData.receivableFeeItemCount) }}</div>
        <div class="statistic-label">{{ $t('feeTab.feeItems') }}</div>
      </div>
    </div>

    <el-tabs v-model="activeFeeTab" type="card" class="fee-data-tabs">
      <el-tab-pane :label="$t('feeTab.summary')" name="summary" lazy>
        <FeeCostTable mode="summary" :type="0" :file-name="$t('feeTab.receivableSummaryFileName')" :fee-item-list="feeItemList" :charge-unit-list="chargeUnitList" :outer-order-no="outerOrderNo" @refresh-card="getOrderQuateCard" />
      </el-tab-pane>
      <el-tab-pane :label="$t('feeTab.detail')" name="detail" lazy>
        <FeeCostTable mode="detail" :type="0" :file-name="$t('feeTab.receivableDetailFileName')" :fee-item-list="feeItemList" :charge-unit-list="chargeUnitList" :outer-order-no="outerOrderNo" @refresh-card="getOrderQuateCard" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { logisticApi } from '@/api';
import FeeCostTable from './FeeCostTable.vue';

export default {
  name: 'FeeReceivablePage',
  components: { FeeCostTable },
  props: {
    outerOrderNo: {
      type: String,
      default: '',
    },
    feeItemList: {
      type: Array,
      default: () => [],
    },
    chargeUnitList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeFeeTab: 'summary',
      cardData: {},
    };
  },
  watch: {
    outerOrderNo: {
      immediate: true,
      handler() {
        this.getOrderQuateCard();
      },
    },
  },
  methods: {
    getOrderQuateCard() {
      const { outerOrderNo } = this;
      if (!outerOrderNo) {
        this.cardData = {};
        return;
      }
      logisticApi.getOrderQuateCard(outerOrderNo).then(res => {
        this.cardData = res || {};
      });
    },
    displayCardValue(value) {
      return value === undefined || value === null || value === '' ? '--' : value;
    },
  },
};
</script>

<style lang="scss" scoped>
.statistics-container {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.statistic-card {
  padding: 20px;
  border-left: 4px solid #409eff;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &.card-warning {
    border-left-color: #e6a23c;
  }

  &.card-success {
    border-left-color: #67c23a;
  }
}

.statistic-value {
  margin-bottom: 8px;
  color: #303133;
  font-size: 28px;
  font-weight: 700;
}

.statistic-value--amount {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.statistic-currency {
  color: #606266;
  font-size: 14px;
  font-weight: 500;
}

.statistic-label {
  color: #909399;
  font-size: 14px;
}

.fee-data-tabs {
  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }
}

@media (max-width: 900px) {
  .statistics-container {
    grid-template-columns: 1fr;
  }
}
</style>
